export default __webpack_public_path__ + "station-defect-gears-gray.png?45abf73b67958e0b1661a713ddc90d4d";